import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave, fnGetTableById } from "@shared/api/restApi";
import {
  getInitPopUp,
  getTablebySql,
  getInitPopUpData,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTabHeader from "@shared/components/SnTabHeader";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { dateToString } from "@shared/utils/DateUtils";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}
interface RowData {
  KeyField?: string;

  [key: string]: any;
}
const SN_PRD_WMO_REG_002_TEX_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const [gridFocus, setGridFocus] = useState(false);
    const [popupParent, setPopupParent] = useState<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });
    useImperativeHandle(ref, () => ({
      getSelectedValue: () => {
        onSave();
      },
      getSelectedRow: () => {
        const rows: any[] = [];

        gridRefs.current["grid1"].current.forEachFilteredNode((node: any) => {
          rows.push(node.data);
        });

        return rows;
      },
    }));
    //#endregion
    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);
    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_WMO_REG_002_TEX_POP_001",
            {}
          );
          setColums({
            grid1: rtn.grid.grid1,
          });
          await new Promise((resolve) => setTimeout(resolve, 0));
          await onSearch();
        } catch (error: any) {}
      };
      fetchform();
    }, []);

    useEffect(() => {
      gridRefs.current["grid1"].current.selectAndFocusRow(0);
      setGridFocus(false);
    }, [gridFocus]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_prd_wmo_reg_002_tex_pop_01",
            params: {
              cd_firm: userInfo.cd_firm,
              no_wo: selectedData.data.no_wo,
              cd_op: selectedData.data.cd_op,
            },
          };

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0],
          });
          if (data[0] && data[0].length > 0) {
            await new Promise((resolve) => setTimeout(resolve, 50));

            setGridFocus(true);
          } else {
            gridRefs.current["grid1"].current.resetUpdate();
          }
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    const onSave = async () => {
      gridRefs.current["grid1"].current?.stopEditing();
      const grid = gridRefs.current["grid1"].current?.getChange();

      if (grid.modifiedRowcount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const SaveData = {
        prd_wovariant_tex: grid,
      };
      let sumQtwo = 0,
        sumQtdivide = 0;
      gridRefs.current["grid1"].current.forEachFilteredNode((row: any) => {
        sumQtwo += row.data.qt ?? 0;
        sumQtdivide += row.data.qt_divide ?? 0;
      });
      const sqlQuery1 = {
        sql: "update prd_woproc_tex set qt_wo = :qt_wo, qt_divide = :qt_divide where cd_firm = :cd_firm and no_wo = :no_wo and cd_op = :cd_op",
        cd_firm: userInfo.cd_firm,
        no_wo: selectedData.data.no_wo,
        cd_op: selectedData.data.cd_op,
        qt_wo: sumQtwo,
        qt_divide: sumQtdivide,
      };
      await getTablebySql(sqlQuery1);
      await fnSave("SN_PRD_WMO_REG_002_TEX_SAVE_01_POP", SaveData);
    };
    //#endregion

    const onBtnsClick = async (id: string) => {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
    };
    const onAddRow = async () => {
      try {
        const today = dateToString(new Date());
        if (selectedData.data.cd_op === "T120") {
          let maxNoLine =
            gridRefs.current["grid1"].current.getMaxValue("no_line_tex");
          const newRow = {
            cd_firm: userInfo.cd_firm,
            cd_item: selectedData.data.cd_item,
            no_style: selectedData.data.no_style,
            cd_op: selectedData.data.cd_op,
            nm_op: selectedData.data.nm_op,
            dc_dummy01: selectedData.data.dc_unit,
            cd_user_reg: userInfo.cd_user,
            dt_wo: today,
            no_line_tex: maxNoLine + 1,
            no_wo: selectedData.data.no_wo,
            no_line_wo: selectedData.data.no_line,
            qt: 0,
            qt_divide: 0,
          };
          gridRefs.current["grid1"].current?.addRow(newRow);
        } else if (selectedData.data.cd_op === "T140") {
          let maxNoLine =
            gridRefs.current["grid1"].current.getMaxValue("no_line_tex");
          const wovariant_tex_op = {
            id: "wovariant_tex_op",
            params: {
              cd_firm: userInfo.cd_firm,
              no_wo: selectedData.data.no_wo,
              cd_op: "T120",
            },
          };
          const data = await fnGetTableById(wovariant_tex_op);
          if (data.length !== 0) {
            data.forEach((row: any, idx: number) => {
              const newRow = {
                cd_firm: userInfo.cd_firm,
                cd_item: selectedData.data.cd_item,
                no_style: selectedData.data.no_style,
                no_wo: selectedData.data.no_wo,
                cd_op: selectedData.data.cd_op,
                nm_op: selectedData.data.nm_op,
                dc_dummy01: selectedData.data.dc_unit,
                cd_var2: row.cd_var2,
                dc_rmk: row.dc_rmk,
                qt: Math.floor(row.qt / selectedData.qt_dummy01),
                qt_divide: row.qt_divide,
                no_line_wo: selectedData.data.no_line,
                cd_user_reg: userInfo.cd_user,
                dt_wo: today,
                no_line_tex: maxNoLine + idx + 1,
              };
              gridRefs.current["grid1"].current?.addRow(newRow);
            });
          }
        } else {
          let maxNoLine =
            gridRefs.current["grid1"].current.getMaxValue("no_line_tex");
          const wovariant_tex_op = {
            id: "wovariant_tex_op",
            params: {
              cd_firm: userInfo.cd_firm,
              no_wo: selectedData.data.no_wo,
              cd_op: "T120",
            },
          };
          const data = await fnGetTableById(wovariant_tex_op);
          if (data.length !== 0) {
            data.forEach((row: any, idx: number) => {
              const newRow = {
                cd_firm: userInfo.cd_firm,
                cd_item: selectedData.data.cd_item,
                no_style: selectedData.data.no_style,
                no_wo: selectedData.data.no_wo,
                cd_op: selectedData.data.cd_op,
                nm_op: selectedData.data.nm_op,
                dc_dummy01: selectedData.data.dc_unit,
                cd_var2: row.cd_var2,
                dc_rmk: row.dc_rmk,
                qt: row.qt,
                qt_divide: row.qt_divide,
                no_line_wo: selectedData.data.no_line,
                cd_user_reg: userInfo.cd_user,
                dt_wo: today,
                no_line_tex: maxNoLine + idx + 1,
              };
              gridRefs.current["grid1"].current?.addRow(newRow);
            });
          }
        }
      } catch (error: any) {}
    };
    //#region InitnewRowH

    const onDeleteRow = async () => {
      if (gridRefs.current["grid1"].current.getDisplayedRowCount() < 1) {
        return;
      }
      gridRefs.current["grid1"].current?.deleteSelectedRows();
      await new Promise((resolve) => setTimeout(resolve, 0));
    };
    const onCellValueChanged = async (event: CellValueChangedEvent) => {
      if (!event) return;
      const colId = event.colId;
      const rowData = event.rowData;
      const rowNode = event.rowNode;
      if (colId === "cd_var2") {
        const sqlQuery1 = {
          sql: "select dc_rmk from prd_wovariant_tex where cd_firm = :cd_firm and cd_var2 = :cd_var2 and cd_op = 'T120' and (dc_rmk is not null or dc_rmk <> '')order by tm_reg desc limit 1",
          cd_firm: userInfo.cd_firm,
          cd_var2: rowData.cd_var2,
        };
        const data = await getTablebySql(sqlQuery1);
        if (data.length !== 0) rowNode.setDataValue("dc_rmk", data[0].dc_rmk);
      } else if (colId === "qt_divide") {
        rowNode.setDataValue(
          "qt",
          selectedData.qt_dummy04 * rowData.qt_divide,
          "noEvent"
        );
      }
    };
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCellValueChanged: onCellValueChanged,
          },
        },
      }),
      [columns, dataSources]
    );
    return (
      <div className="h-full flex flex-col">
        <div className="mb-1">
          <SnTabHeader
            onBtnAddClick={onBtnsClick}
            onBtnDeleteClick={onBtnsClick}
          />
        </div>
        <div className="w-full h-full flex space-x-1">
          <div className="w-[99%] flex flex">
            <SnGrid
              ref={gridRefs.current["grid1"]} // Grid Name
              columnConfig={grids.grid1.columns} // 컬럼 설정 전달
              rowData={grids.grid1.dataSource} // Datasource
              etcProps={{
                isEditable: true,
                rowSelection: "single",
                popupParent: popupParent,
              }}
              events={grids.grid1.events}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_PRD_WMO_REG_002_TEX_POP_001;
